import React, {
  forwardRef,
  memo,
  PropsWithChildren,
  useEffect,
  useRef,
} from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  perView?: number;
  colGap?: number;
  rowGap?: number;
  offsetLR?: number;
  scrollInit?: boolean;
  draggable?: boolean;
  className?: string;
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

const Prd2LineScrollBar = forwardRef(
  (
    {
      className,
      perView = 2,
      offsetLR = 20,
      colGap = 6,
      rowGap = 24,
      children,
      scrollInit = false,
      draggable = true,
      onTouchStart,
      onTouchEnd,
      onScroll,
    }: PropsWithChildren<IProps>,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const scrollRef = useRef<any>(null);

    const param = {
      className: classNameBind([
        'items-scrollBar type-prd2line list',
        className || '',
      ]),
      $perView: perView,
      $offsetLR: offsetLR,
      $colGap: colGap,
      $rowGap: rowGap,
      ref: scrollInit ? scrollRef : ref,
      draggable,
    };

    useEffect(() => {
      if (scrollInit)
        if (scrollRef.current) scrollRef.current.scrollTo({ left: 0 });
    }, [children, scrollInit]);

    return (
      <S.Prd2LineScrollBar
        {...param}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onScroll={onScroll}
      >
        {children}
      </S.Prd2LineScrollBar>
    );
  }
);
Prd2LineScrollBar.displayName = 'Prd2LineScrollBar';
export default memo(Prd2LineScrollBar);
